export const SubmittedActionTypes = {
  View: "view"
};
